import { Popover, Box, Typography, Button, styled } from '@mui/material';

// Custom styled Popover component with arrow
const ArrowPopover = styled(Popover)(({ theme }) => ({
    '& .MuiPopover-paper': {
        position: 'relative',
        padding: theme.spacing(2),
        borderRadius: '5px',
        maxWidth: 280,
        backgroundColor: "#FFFFFF99",
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
        overflow: 'visible',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',

        // Arrow at the top using CSS triangles
        '&::before': {
            content: '""',
            position: 'absolute',
            width: 0,
            height: 0,
            bottom: '100%',
            left: '94%',
            transform: 'translateX(-50%)',
            borderLeft: '8px solid transparent !important',
            borderRight: '8px solid transparent !important',
            borderBottom: '8px solid #FFFFFF99 !important',
        }
    }
}));

const ArrowConfirmationPopover = ({ anchorEl, onClose, onConfirm, confirmationMessage, startIcon }: any) => {
    const open = Boolean(anchorEl);
    const id = open ? 'delete-popover' : undefined;

    return (
        <ArrowPopover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                sx: {
                    width: '280px',
                    padding: '15px 20px',
                    marginTop: '5px',
                }
            }}
        >
            <Box display="flex" flexDirection="column" alignItems="center">
                <Box display="flex" alignItems="center" mb={1.5} width="100%">
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        width: '100%'
                    }}>
                        {startIcon &&
                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '30px',
                                height: '30px'
                            }}>
                                <img src={startIcon} alt='' />
                            </Box>
                        }
                        <Typography fontSize={14} fontWeight={600}>
                            {confirmationMessage}
                        </Typography>
                    </Box>
                </Box>
                <Box display="flex" gap={2} justifyContent="center" width="100%" mt={1}>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onConfirm}
                        sx={{
                            backgroundColor: '#FFFFFF80',
                            color: '#000',
                            textTransform: 'none',
                            borderRadius: 1,
                            padding: '5px 16px',
                            minWidth: '80px',
                            fontSize: '14px',
                            fontWeight: 500,
                            boxShadow: "0px 0px 2px 0px #0000004D",
                            '&:hover': {
                                backgroundColor: '#FFFFFF80',
                                boxShadow: "0px 0px 2px 0px #0000004D"
                            }
                        }}
                    >
                        Yes
                    </Button>
                    <Button
                        variant="contained"
                        size="small"
                        onClick={onClose}
                        sx={{
                            backgroundColor: '#0C8CE9',
                            color: '#fff',
                            textTransform: 'none',
                            borderRadius: 1,
                            padding: '5px 16px',
                            minWidth: '80px',
                            boxShadow: 'none',
                            fontSize: '14px',
                            fontWeight: 500,
                            '&:hover': {
                                backgroundColor: '#0C8CE9',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        No
                    </Button>
                </Box>
            </Box>
        </ArrowPopover>
    );
};

export default ArrowConfirmationPopover;